import {css} from 'lit';
import {tablet} from '../../js/services/const';

export default css`
  :host {
    display: flex;
    align-items: center;
    position: relative;
    box-sizing: border-box;
    font-size: 0;
    line-height: 0;
  }

  @media (min-width: ${tablet}px) {
    :host(:hover) ::slotted(ui-social-share) {
      background-color: var(--cp-grey-light-6);
    }

    ::slotted(ui-social-share[type='whatsapp']) {
      display: none;
    }
  }
`;
